import React  from 'react'        ;
import moment from 'jalali-moment';

import api       from '../../../../api';
import utils     from '../../../../utils';
import values    from '../../../../values';
import Cookies   from 'js-cookie';
import Context   from '../../../../context';
import constants from '../../../../values/constants';
import firstAndEndOfMonth   from '../../../../utils/firstAndEndOfMonth';
import convertNumberToPrice from '../../../../utils/convertNumberToPrice';
import CustomDropDownSearch from '../../../../components/CustomDropDownMultiSearch';

import {IDiscountDriverFactor, IItem} from '../../../../types/common.interface';
import { useQuery       } from 'react-query';
import { useTranslation } from 'react-i18next';
import {
  MONTH,
  OFFLINE_PAYER_WAY,
  SETTELMENT_FILTER,
  DRIVER_OFFLINE_PAYER_TYPE,
} from '../../../../values/dropdownItems';
import {
  CustomView,
  TableHeader,
  CustomModal,
  CustomInput,
  TableLoading,
  TableNullData,
  CustomButton2,
  UserInformation,
  CustomRadioButtonGroup, CustomDropdownSearch, ResponsiveView, CustomIcon,
} from '../../../../components';

import './index.scss';
import convertPriceToNumber from "../../../../utils/convertPriceToNumber";
import {SERVICE_HEADER_FOR_ADMIN} from "../../../../values/tableHeaders";
import {updatePriceFactor} from "../../../../api/method.put/administrator";

const PayAllServices: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();

  const { showModal, setShowModal, selectedDriver, payFunction } = React.useContext(Context.DriverScreen);

  const [selectedFactor, setSelectedFactor] = React.useState<any>();
  const [isOpenUpdatePrice, setIsOpenUpdatePrice] = React.useState<boolean>(false);
  const [selectedPayerWay, setSelectedPayerWay] = React.useState<IItem>(OFFLINE_PAYER_WAY[1]);
  const [selectedPayerType, setSelectedPayerType] = React.useState<IItem>(DRIVER_OFFLINE_PAYER_TYPE[0]);
  const [fishNumber, setFishNumber] = React.useState<string>("");
  const [price, setPrice] = React.useState<number>(0);
  const [discount, setDiscount] = React.useState<IDiscountDriverFactor>({
    type: 'COMPANY',
    value: 0,
  });

  const [errors, setErrors] = React.useState<any>({
    factorList: "",
    fishNumber: "",
    payWay    : "",
  });

  const [selectedYear, setSelectedYear] = React.useState(SETTELMENT_FILTER[0]);
  const [selectedMonth, setSelectedMonth] = React.useState<IItem>(
    MONTH.find(
      (item) => item._id === moment().locale("fa").subtract(20, "days").format("jM")
    ) as IItem
  );
  const [isLoading, setIsLoading] = React.useState(false);

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const discountRoles: Array<IItem> = [
    {_id: 0, value: 'ADMIN'  , name: 'ادمین'},
    {_id: 1, value: 'COMPANY', name: 'شرکت' },
  ];

  const [selectedDiscountRole, setSelectedDiscountRole] = React.useState<IItem | null>(discountRoles[0]);
  const [discountPrice, setDiscountPrice] = React.useState<number>(0);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const driverFactorInfo = useQuery(
    ['driverFactorInfo', discount, selectedDriver, selectedYear.name, selectedMonth?._id],
    () =>
      api.get.common.getAllDriverFactors({
        startAt: (selectedYear.name &&
          selectedMonth?._id &&
          firstAndEndOfMonth(selectedYear.name, selectedMonth?._id as string)
            .firstDay) as string,
        endAt: (selectedYear.name &&
          selectedMonth?._id &&
          firstAndEndOfMonth(selectedYear.name, selectedMonth?._id as string)
            .lastDay) as string,
        driverId: selectedDriver?._id,
        discount
      }),
    {
      enabled: showModal === "DRIVER_PAY_SERVICES_PRICE",
      cacheTime: 1000,
    }
  );

  async function updateFactorPrice(): Promise<void> {
    setIsLoading(true);
    await api.put.administrator.updatePriceFactor(selectedFactor?._id, price);
    await driverFactorInfo.refetch();
    setPrice(0);
    setSelectedFactor(undefined);
    setIsOpenUpdatePrice(false);
    setIsLoading(false);
  }

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function onSubmitPay(): Promise<void> {
    setIsLoading(true);
    let errorList = {};
    if (fishNumber === '' ) {errorList = {...errorList, fishNumber: t('enter_fish_number')}}
    if (!selectedPayerWay ) {errorList = {...errorList, payWay    : t('select_pay_way'   )}}
    if (!selectedPayerType) {errorList = {...errorList, payerType : t('select_payer_type')}}

    if (!selectedPayerWay || !selectedPayerWay || !fishNumber) {
      setErrors(errorList);
    } else {
      await payFunction!({
        discount,
        fishId: fishNumber,
        offlinePayType: selectedPayerWay?.value as string,
        driverId: selectedDriver?._id,
        startAt: (selectedYear.name &&
          selectedMonth?._id &&
          firstAndEndOfMonth(selectedYear.name, selectedMonth?._id as string)
            .firstDay) as string,
        endAt: (selectedYear.name &&
          selectedMonth?._id &&
          firstAndEndOfMonth(selectedYear.name, selectedMonth?._id as string)
            .lastDay) as string,
      });
    }
    setIsLoading(false);
  }

  function onSelectDiscount(event: IItem): void {
    setSelectedDiscountRole(event as IItem);
  }

  function onChageDiscountValue(event: React.ChangeEvent<HTMLInputElement>): void {
    setDiscountPrice(convertPriceToNumber(event.target.value));
  }

  function handelOnClickEditPrice(event: any): void {
    setSelectedFactor(event);
    setIsOpenUpdatePrice(true);
  }

  function handleOnChangePrice(event:  React.ChangeEvent<HTMLInputElement>):void {
    setPrice(Number(event.target.value));
  }

  function hadleOnCloseUpdatePrice(): void {
    setPrice(0);
    setSelectedFactor(undefined);
    setIsOpenUpdatePrice(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect((): void => {
    setDiscount({
      type: selectedDiscountRole?.value as string,
      value: discountPrice,
    })
  }, [discountPrice, selectedDiscountRole]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="show-all-service-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DRIVER_PAY_SERVICES_PRICE"}
        minWidth={"45rem"}
        maxWidth={"50rem"}
        height={"80vh"}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedDriver?.firstName}
                avatar={selectedDriver?.avatar}
                isBlock={!selectedDriver?.driverInformation?.approved?.isApproved}
                lastName={selectedDriver?.lastName}
                phoneNumber={selectedDriver?.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <CustomDropDownSearch
                label="سال"
                items={SETTELMENT_FILTER}
                baseSearch={[]}
                itemName='name'
                onSelectItem={(event: any) => setSelectedYear(event)}
                placeHolder={""}
                defaultItem={selectedYear}
                setSearchedValue={function (event: any): void {}}
                searchedValue={undefined}
              />
            </CustomView.Column>
            <CustomView.Column className="">
              <CustomDropDownSearch
                label="ماه"
                items={MONTH}
                baseSearch={[]}
                itemName='name'
                defaultItem={selectedMonth}
                onSelectItem={(event) => {
                  setSelectedMonth(event);
                }}
                placeHolder={'انتخاب ماه'}
                setSearchedValue={function (event: any): void {}}
                searchedValue={undefined}
              />
            </CustomView.Column>
          </CustomView.Row>
          <div className='table-content-wrapper'>
            <table className='dropdown'>
              <TableHeader
                headers={values.tableHeaders.SERVICE_HEADER_FOR_DRIVER}
              />
              {driverFactorInfo.status === 'loading' ? (
                <TableLoading />
              ) : (
                <>
                  {(driverFactorInfo?.data?.result?.foundedFactorList?.length <=
                    0 ||
                    !driverFactorInfo?.data?.result?.foundedFactorList) && (
                    <TableNullData text={t("driver_has_not_active_service")} />
                  )}

                  <tbody id="driver-table-body-container">
                    {driverFactorInfo?.data?.result?.foundedFactorList?.map(
                      (factor: any, index: number) => {
                        return (
                          <tr
                            key={`driver-${index}`}
                            className={factor?.isClose
                              ? "close-factor" : factor?.status === "PAID"
                              ? "paid-row" : "not-paid-row"
                            }
                          >
                            <td className="pointer">
                              <UserInformation
                                name        = { factor?.student?.firstName           }
                                avatar      = { factor?.student?.avatar              }
                                isBlock     = { factor?.student?.approved?.isApprove }
                                lastName    = { factor?.student?.lastName            }
                                phoneNumber = { factor?.student?.phoneNumber         }
                              />
                            </td>
                            <td className="pointer">
                              <UserInformation
                                name       = { factor?.parent?.firstName           }
                                isBlock    = { factor?.parent?.approved?.isApprove }
                                lastName   = { factor?.parent?.lastName            }
                                phoneNumber= { factor?.parent?.phoneNumber         }
                                hideAvatar
                              />
                            </td>
                            <td>{utils.convertGregorianToJalali({date: factor?.oldSubscriptionDate,})}</td>
                            <td>{utils.convertGregorianToJalali({date: factor?.newSubscriptionDate,})}</td>
                            <td className="pointer">
                              <div>
                                {factor?.isClose ? "بسته شده" : factor.status === "PAID" ? "پرداخت شده" : "پرداخت نشده"}
                              </div>
                            </td>
                            <td className="pointer">
                              {factor?.price && (<div>{convertNumberToPrice(factor?.price)} تومان</div>)}
                            </td>
                            <td>
                              { userType === 'ADMIN' && factor.status === "UN_PAID" && (
                                <CustomIcon icon={'fa fa-hand-holding-dollar'} onClick={() => handelOnClickEditPrice(factor)} />
                              )}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                  <div className="error">
                    {errors.factorList !== "" && errors.factorList}
                  </div>
                </>
              )}
            </table>
            <CustomView.Container className="approve-form-content">
              <CustomView.Row className="content-center">
                <CustomView.Column medium={12}>
                  <CustomView.Row className="radio-button-group">
                    <CustomView.Column medium={12} className="form-colum dropdown">
                      <div className="form-colum input-label right">{t("payWay")}</div>
                      <CustomRadioButtonGroup
                        menus={OFFLINE_PAYER_WAY}
                        selected={selectedPayerWay as IItem}
                        onClick={(event: IItem | null) => {
                          setSelectedPayerWay(event as IItem);
                          setErrors({ ...errors, payWay: "" });
                        }}
                        canNull={false}
                      />
                      <div className="error">{errors.payWay !== "" && errors.payWay}</div>
                    </CustomView.Column>
                    <CustomView.Column medium={12} className="form-colum dropdown">
                      <div className="form-colum input-label right">{t("payer")}</div>
                      <CustomRadioButtonGroup
                        menus={DRIVER_OFFLINE_PAYER_TYPE}
                        selected={selectedPayerType as IItem}
                        onClick={(event: IItem | null) => {
                          setSelectedPayerType(event as IItem);
                          setErrors({ ...errors, payerType: "" });
                        }}
                        canNull={false}
                      />
                      <div className="error">{errors.payerType !== "" && errors.payerType}</div>
                    </CustomView.Column>
                    <CustomView.Column medium={6} className="form-colum dropdown">
                      <CustomInput
                        name="fishNumber"
                        id="fishNumber"
                        label={t("fishNumber")}
                        value={fishNumber}
                        onValueChange={(event) => {
                          setFishNumber(event.target.value);
                          setErrors({ ...errors, fishNumber: "" });
                        }}
                      />
                      <div className="error">{errors.fishNumber !== "" && errors.fishNumber}</div>
                      <hr />
                      <p> اعمال تخفیف </p>
                      <CustomDropdownSearch
                        items={discountRoles}
                        itemName={'name'}
                        defaultItem={selectedDiscountRole}
                        placeHolder={'انتخاب نقش'}
                        onSelectItem={onSelectDiscount}
                        label=''
                      />
                      <ResponsiveView.Column style={{margin: '10px 10px 0 0'}}>
                        <CustomInput
                          label={'قیمت تخفیف به تومان'}
                          id='discountRoles'
                          name='discountRoles'
                          value={String(convertNumberToPrice(discountPrice))}
                          onValueChange={onChageDiscountValue}
                        />
                      </ResponsiveView.Column>
                    </CustomView.Column>
                    <CustomView.Column medium={6} className="form-colum">
                      <CustomInput
                        name="totalPriceDriverToPay"
                        id="totalPriceDriverToPay"
                        label={t('totalPriceDriverToPay')}
                        value={
                          String(
                            convertNumberToPrice(
                              driverFactorInfo.data?.result
                                ?.shareAdminAndCompany
                            )
                          ) + t('toman')
                        }
                        isDisable
                      />
                      <CustomInput
                        id='totalServicePrice'
                        name='totalServicePrice'
                        label={t('totalServicePrice')}
                        value={
                          String(
                            convertNumberToPrice(
                              driverFactorInfo.data?.result?.allPaidPrice
                            )
                          ) + t('toman')
                        }
                        isDisable
                      />
                      {driverFactorInfo?.data?.result?.isDept4Driver2Pay && (
                        <CustomInput
                          id='DebtDriver'
                          name='DebtDriver'
                          label={t('DebtDriver')}
                          value={
                            String(
                              convertNumberToPrice(
                                driverFactorInfo.data?.result
                                  ?.priceDept4Driver2Pay
                              )
                            ) + t('toman')
                          }
                          isDisable
                        />
                      )}
                      {driverFactorInfo?.data?.result?.isDept4Pay2Driver && (
                        <CustomInput
                          id='CreditorDriver'
                          name='CreditorDriver'
                          label={t('CreditorDriver')}
                          value={
                            String(
                              convertNumberToPrice(
                                driverFactorInfo.data?.result
                                  ?.priceDept4Pay2Driver
                              )
                            ) + t('toman')
                          }
                          isDisable
                        />
                      )}
                      <CustomInput
                        id='payToDriver'
                        name='payToDriver'
                        label={t('payToDriver')}
                        value={
                          String(
                            convertNumberToPrice(
                              driverFactorInfo.data?.result?.price4Pay2Driver
                            )
                          ) + t('toman')
                        }
                        isDisable
                      />
                      <CustomInput
                        id='receiveFromDriver'
                        name='receiveFromDriver'
                        label={t('receiveFromDriver')}
                        value={
                          String(
                            convertNumberToPrice(
                              driverFactorInfo.data?.result?.price4Driver2Pay
                            )
                          ) + t('toman')
                        }
                        isDisable
                      />
                    </CustomView.Column>
                  </CustomView.Row>
                </CustomView.Column>
              </CustomView.Row>
              <br />
            </CustomView.Container>
            <div className='pay-button'>
              {(userType === 'ADMIN' || userType === 'COMPANY') && (
                <CustomButton2
                  title={t('pay')}
                  onClick={() => onSubmitPay()}
                  isLoading={isLoading}
                />
              )}
            </div>
          </div>
        </CustomView.Container>
      </CustomModal>
      <CustomModal
        onClose={hadleOnCloseUpdatePrice}
        open={isOpenUpdatePrice}
        minWidth={"35rem"}
        maxWidth={"40rem"}
        height={"23rem"}
      >
        <ResponsiveView.Row id='update-price-factor-4-admin'>
          <p style={{userSelect: 'none'}}>ویرایش قیمت فاکتور</p>
          <table className='update-price-table'>
            <TableHeader headers={values.tableHeaders.SERVICE_HEADER_FOR_ADMIN}/>
              <tbody id="driver-table-body-container">
                <tr key={`admin-udpate-price-factor`} className={"not-paid-row"}>
                  <td className="pointer">
                    <UserInformation
                      name={selectedFactor?.student?.firstName}
                      avatar={selectedFactor?.student?.avatar}
                      isBlock={selectedFactor?.student?.approved?.isApprove}
                      lastName={selectedFactor?.student?.lastName}
                      phoneNumber={selectedFactor?.student?.phoneNumber}
                    />
                  </td>
                  <td className="pointer">
                    <UserInformation
                      name={selectedFactor?.parent?.firstName}
                      isBlock={selectedFactor?.parent?.approved?.isApprove}
                      lastName={selectedFactor?.parent?.lastName}
                      phoneNumber={selectedFactor?.parent?.phoneNumber}
                      hideAvatar
                    />
                  </td>
                  <td>{utils.convertGregorianToJalali({date: selectedFactor?.oldSubscriptionDate,})}</td>
                  <td>{utils.convertGregorianToJalali({date: selectedFactor?.newSubscriptionDate,})}</td>
                  <td className="pointer">
                    {selectedFactor?.price && (<div>{convertNumberToPrice(selectedFactor?.price)} تومان</div>)}
                  </td>
                </tr>
              </tbody>
          </table>
          <ResponsiveView.Column medium={12} className={'input-wrapper'}>
            <CustomInput
              label={'قیمت جدید را وارد کنید'}
              placeHolder={selectedFactor?.price}
              value={price ? price : selectedFactor?.price}
              onValueChange={handleOnChangePrice}
            />
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={6}>
            <CustomButton2 title='لغو' onClick={hadleOnCloseUpdatePrice} isLoading={isLoading} type='danger'/>
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={6}>
            <CustomButton2 title='تایید' onClick={updateFactorPrice} isLoading={isLoading} type='primary'/>
          </ResponsiveView.Column>
        </ResponsiveView.Row>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default PayAllServices;
